<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>

    </nav> -->
    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <div class="main-panel" >
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;" [hidden]="isShownWrite">
                <div class="page-header">
                    <h2 class="page-title text-primary">User Rights</h2>
                </div>

                <div class="form">
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-3">
                            <label>Role Name </label><span style="color: red;">*</span><br />
                            <input type="text" id="RoleName" [(ngModel)]="RoleName" maxlength="12"
                                style="text-align: left;" class="txt-input" />
                        </div>
                        
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-3">
                            <label>Audit Upload </label><br />
                            <input type="checkbox" [(ngModel)]="AduitUploadRead"> Read
                            <input type="checkbox" [(ngModel)]="AduitUploadWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Audit Output </label><br />
                            <input type="checkbox" [(ngModel)]="AuditOutputRead"> Read
                            <input type="checkbox" [(ngModel)]="AuditOutputWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>CHA </label><br />
                            <input type="checkbox" [(ngModel)]="ChaRead"> Read
                            <input type="checkbox" [(ngModel)]="ChaWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Country </label><br />
                            <input type="checkbox" [(ngModel)]="CountryRead"> Read
                            <input type="checkbox" [(ngModel)]="CountryWrite"> Write
                        </div>
                    </div>

                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-3">
                            <label>Currency</label><br />
                            <input type="checkbox" [(ngModel)]="CurrencyRead"> Read
                            <input type="checkbox" [(ngModel)]="CurrencyWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Exchange Rate </label><br />
                            <input type="checkbox" [(ngModel)]="ExchangeRead"> Read
                            <input type="checkbox" [(ngModel)]="ExchangeWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Port </label><br />
                            <input type="checkbox" [(ngModel)]="PortRead"> Read
                            <input type="checkbox" [(ngModel)]="PortWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Custom Notification </label><br />
                            <input type="checkbox" [(ngModel)]="CustomRead"> Read
                            <input type="checkbox" [(ngModel)]="CustomWrite"> Write
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-3">
                            <label>Exim Notification </label><br />
                            <input type="checkbox" [(ngModel)]="EximRead"> Read
                            <input type="checkbox" [(ngModel)]="EximWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>AntiDumping Notification </label><br />
                            <input type="checkbox" [(ngModel)]="AntiDumbingRead"> Read
                            <input type="checkbox" [(ngModel)]="AntiDumbingWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Client File Upload </label><br />
                            <input type="checkbox" [(ngModel)]="ClientRead"> Read
                            <input type="checkbox" [(ngModel)]="ClientWrite"> Write
                        </div>
                        <!-- <div class="col-md-3">
                            <label>Country </label><br />
                            <input type="checkbox" [(ngModel)]="CountryRead"> Read
                            <input type="checkbox" [(ngModel)]="CountryWrite"> Write
                        </div> -->
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-3">
                            <label>Onboarding </label><br />
                            <input type="checkbox" [(ngModel)]="OnboardingRead"> Read
                            <input type="checkbox" [(ngModel)]="OnboardingWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Contracts </label><br />
                            <input type="checkbox" [(ngModel)]="ContractsRead"> Read
                            <input type="checkbox" [(ngModel)]="ContractsWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>NDA </label><br />
                            <input type="checkbox" [(ngModel)]="NdaRead"> Read
                            <input type="checkbox" [(ngModel)]="NdaWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Employee </label><br />
                            <input type="checkbox" [(ngModel)]="EmployeeRead"> Read
                            <input type="checkbox" [(ngModel)]="EmployeeWrite"> Write
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-3">
                            <label>Assign Employee </label><br />
                            <input type="checkbox" [(ngModel)]="AssignEmpRead"> Read
                            <input type="checkbox" [(ngModel)]="AssignEmpWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Parts </label><br />
                            <input type="checkbox" [(ngModel)]="PartsRead"> Read
                            <input type="checkbox" [(ngModel)]="PartsWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>License </label><br />
                            <input type="checkbox" [(ngModel)]="LicenseRead"> Read
                            <input type="checkbox" [(ngModel)]="LicenseWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Bond </label><br />
                            <input type="checkbox" [(ngModel)]="BondRead"> Read
                            <input type="checkbox" [(ngModel)]="BondWrite"> Write
                        </div>
                    </div>

                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-md-3">
                            <label>Bank Guarantee </label><br />
                            <input type="checkbox" [(ngModel)]="BankRead"> Read
                            <input type="checkbox" [(ngModel)]="BankWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>Import Part Master </label><br />
                            <input type="checkbox" [(ngModel)]="ImportPartRead"> Read
                            <input type="checkbox" [(ngModel)]="ImportPartWrite"> Write
                        </div>
                        <div class="col-md-3">
                            <label>User Rights </label><br />
                            <input type="checkbox" [(ngModel)]="UserRightsRead"> Read
                            <input type="checkbox" [(ngModel)]="UserRightsWrite"> Write
                        </div>
                        
                    </div>
                   
                    <div class="row">
                        <div class="col-lg-6" style="padding-top: 39px;">
                            <label>Description </label><br />
                            <input type="text" id="Description" [(ngModel)]="Description" maxlength="3"
                                style="text-align: left;" class="txt-input" />
                          </div>
                        <div class="col-lg-2" style="padding-top: 39px;" [hidden]="isShownActive">
                            <input type="checkbox" [(ngModel)]="Status"> Set As Inactive
                          </div>
                        <div class="col-lg-4" style="padding-top: 30px;">  
                            <button class="bttn-save " (click)="SubmitClick()" [hidden]="isShownSaveBtn">SAVE</button> &nbsp;&nbsp;
                            <button class="bttn-Update" (click)="UpdateUserRights()" [hidden]="isShownUpdateBtn">Update</button>&nbsp;&nbsp;
                            <button class="bttn-clear " (click)="ClearClick()">CLEAR</button>
                        </div>
                    </div>
                    
                    <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                        <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
                        <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
                    </div>
                </div>
            </div>



            <div class="content-wrapper">
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">
                            <div class="card-body" style="width:fit-content;">
                                <div class="row">
                                    <div class="col-12 grid-margin" >
                                        <div class="card">
                                            <div class="card-body" style="padding: 0;">
                                                <div class="col-lg-12 form-inline"
                                                    style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                    <div class="col-lg-4"></div>
                                                    <div class="col-lg-8 " style="padding-right:0px;">
                                                        <div class="form-group" style="padding-left:65px;">
                                                            <div class="input-group">
                                                                <input type="text" placeholder="Search"
                                                                  [(ngModel)]="searchText" (keyup)="applyFilter($event.target.value)" class="txt-Search"> <i
                                                                  class="fa fa-search fa-2x" style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>
                                                              
                                                            </div>
                                                            <button type="button" class="btn btn-sm ">
                                                                <img src="../../assets/ExportPDF.png" />
                                                            </button>
                                                            <button type="button" class="btn  btn-sm">
                                                                <img src="../../assets/ExportExcel.png"
                                                                    (click)="exportexcel()" style="cursor: pointer;" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>



                                                <div class="col-sm-12 mat-elevation-z8"
                                                    style="box-shadow: unset;padding: 0px ; overflow: scroll;" #TABLE>
                                                    <table mat-table [dataSource]="dataSource" #table
                                                        style="width: 100%;" matSortmat-table [dataSource]="dataSource"
                                                        #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="color: black !important;background-color: white">
                                                                S.NO </th>
                                                            <td mat-cell *matCellDef="let item; let j = index">
                                                                {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="roleName">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header 
                                                                style="color: black !important;background-color: white">
                                                                Role Name</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditUserRights(element)"
                                                                style="cursor: pointer;"> {{element.roleName}}
                                                            </td>
                                                        </ng-container>
                                                        <!-- <ng-container matColumnDef="screens">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header 
                                                                style="color: black !important;background-color: white">
                                                                Screens</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditUserRights(element)"
                                                                style="cursor: pointer;"> {{element.screens}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="description">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header 
                                                                style="color: black !important;background-color: white">
                                                                Description</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditUserRights(element)"
                                                                style="cursor: pointer;"> {{element.description}}
                                                            </td>
                                                        </ng-container> -->
                                                        <ng-container matColumnDef="status">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header 
                                                                style="color: black !important;background-color: white">
                                                                Status</th>
                                                            <td mat-cell *matCellDef="let element" (click)="EditUserRights(element)"
                                                                style="cursor: pointer;"> {{element.status}}
                                                            </td>
                                                        </ng-container>
                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                        showFirstLastButtons></mat-paginator>
                                                </div>



                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4">
                                       
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- partial:../../partials/_footer.html -->
            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>

                    </span>

                </div>
            </footer>
            <!-- partial -->
        </div>
    </div>
</div>
